import { useGame, ITEM_NAMES } from '../state/useGame';
import { equipSlotFor } from '../domain/economy/equipment';

/**
 * Appears while a transfer source is selected. Gives the non-drag paths:
 * whole-stack and single-unit quick moves to the other container, an equip
 * action for gear, and an explicit cancel.
 */
export function TransferToolbar() {
  const selected = useGame((s) => s.selected);
  const state = useGame((s) => s.state);
  const quickMove = useGame((s) => s.quickMove);
  const selectSlot = useGame((s) => s.selectSlot);
  const equipFromSlot = useGame((s) => s.equipFromSlot);

  if (!selected) return null;
  const stack = state[selected.container][selected.index];
  if (!stack) return null;

  const targetName = selected.container === 'bank' ? 'inventory' : 'bank';
  const equippable = equipSlotFor(stack.itemId) !== null;

  return (
    <div className="transfer-toolbar" role="toolbar" aria-label="Transfer actions">
      <span className="transfer-info">
        <strong>{ITEM_NAMES[stack.itemId]}</strong> ×{stack.qty} selected
      </span>
      <button onClick={() => quickMove(1)}>Move 1 to {targetName}</button>
      <button onClick={() => quickMove()}>Move all to {targetName}</button>
      {equippable && (
        <button
          aria-label={`Equip ${ITEM_NAMES[stack.itemId]}`}
          onClick={() => equipFromSlot(selected)}
        >
          Equip
        </button>
      )}
      <button onClick={() => selectSlot(null)}>Cancel</button>
    </div>
  );
}
